import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

// Import Libraries
import { Helmet } from 'react-helmet'

// Import Components
import Screen from '../../../components/accounts/Screen'
import PageTitle from '../../../components/accounts/PageTitle'
import JobCard from '../../../components/accounts/JobCard'
import JobCard2 from '../../../components/accounts/JobCard2'

const JobsList = () => {
  return (
    <Screen>
      <Helmet>
        <title>Jobs Listings</title>
      </Helmet>
      <PageTitle title='Jobs List' />
      <Container fluid className='p-0'>
        <Row>
          <Col md={12}>
            <JobCard />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <JobCard2 />
          </Col>
        </Row>
      </Container>
    </Screen>
  )
}

export default JobsList
